import * as angular from "angular";
import {IController} from "angular";

export class resourceAllocationAgentAssignmentTableRowCtrl implements IController {

  agentBinding: any;
  isShowAvailability: boolean;
  onAssign: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationAgentAssignmentTableRow', {
    bindings: {
      agentBinding: '<',
      isShowAvailability: '<',
      onAssign: '&'
    },
    template: require('./resource-allocation-agent-assignment-table-row.html').default,
    controller: resourceAllocationAgentAssignmentTableRowCtrl
  });
